import axios from 'axios';

export async function fetchQAFeedbackForProject(projectId, accessToken, get = axios.get) {
  const id = Number(projectId);
  if (!Number.isSafeInteger(id) || id <= 0) return [];
  const siteId = process.env.REACT_APP_SHAREPOINT_BMS_SITE_ID;
  const listId = process.env.REACT_APP_QAFEEDBACK_LIST_ID;
  if (!siteId || !listId) throw new Error('QA Feedback SharePoint configuration is missing.');
  const base = `https://graph.microsoft.com/v1.0/sites/${siteId}/lists/${listId}/items`;
  let nextLink = `${base}?$expand=fields&$filter=${encodeURIComponent(`fields/ProjectID eq ${id}`)}`;
  const items = [];
  const seen = new Set();
  // Follow pagination only within the server-filtered result for this project.
  while (nextLink && !seen.has(nextLink)) {
    if (new URL(nextLink).origin !== 'https://graph.microsoft.com') throw new Error('Invalid QA Feedback pagination URL.');
    seen.add(nextLink);
    const { data } = await get(nextLink, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
        // Permit the project filter until ProjectID is indexed in SharePoint.
        // Large lists may still reject non-indexed queries; do not fetch the whole list.
        Prefer: 'HonorNonIndexedQueriesWarningMayFailRandomly',
      },
    });
    if (Array.isArray(data.value)) items.push(...data.value);
    nextLink = data['@odata.nextLink'] || null;
  }
  return items;
}
